export function flipHorizontally(img, x, y, ctx) {
  ctx.translate(x + img.width, y);
  ctx.scale(-1, 1);
  ctx.drawImage(img, 0, 0);

  // clean up -- reset transformations to default
  ctx.setTransform(1, 0, 0, 1, 0, 0);
}
